import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../../../components/Settings/ProfileSettingsPage'
import { useAutoSaveSettings } from '../../../components/Settings/useAutoSaveSettings'
import PhysicalCapacityForm from '../../../screens/onboarding/forms/PhysicalCapacityForm'

export const Route = createFileRoute('/_authenticated/settings/physical-capacity')({
  component: PhysicalCapacitySettings,
})

function PhysicalCapacitySettings() {
  const { save, retry, status } = useAutoSaveSettings()

  return (
    <ProfileSettingsPage
      title="Physical capacity"
      description="So we never suggest something that isn't actually doable for you."
      saveStatus={status}
      onRetry={retry}
    >
      {/* The starting dose is not sent: the API derives it from the baseline and headroom. */}
      <PhysicalCapacityForm onSubmit={(physicalCapacity) => save({ physicalCapacity })} autoSave />
    </ProfileSettingsPage>
  )
}
